import PrefixEnum from '../prefixes'

export default Object.freeze({
    'lola-weippert.gymondo.fitness': PrefixEnum.POWER,
})
